var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"body-2 ma-4 pa-4 justify text-center"},[_c('img',{attrs:{"src":require("@/assets/logo.png"),"alt":"logo"}}),_c('h1',{staticClass:"display-2 font-weight-thin"},[_vm._v("Shpia")])])
}
var staticRenderFns = []

export { render, staticRenderFns }